"use strict";

import BaseDashboard from "./base_dashboard";

class DefaultDashboard extends BaseDashboard {

    constructor($rootScope, $http, $scope, $state) {
        super($rootScope, $http, $scope, $state);
        this.upcoming = [];
    }

    applyNewData(data) {
        this.upcoming = data;
    }

}

export default [() => {
    return {
        templateUrl: '/partial/app.partials.dashboard.default_dashboard',
        replace: true,
        controller: [
            '$rootScope',
            '$http',
            '$scope',
            '$state',
            DefaultDashboard,
        ],
        controllerAs: 'ctrl',
        scope: {},
    };
}];
